// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-event td {
    background-color: #265985 !important;
    color: #dee2e6 !important;
}

.group-calendar-event td {
    background-color: #5b5d58 !important;
    color: #dee2e6 !important;
}

.calendar-event-from-log td {
    background-color: #ead2ac !important;
    color: #363636 !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Usercalendar/Searchevent/Searchevent.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B","sourcesContent":[".calendar-event td {\r\n    background-color: #265985 !important;\r\n    color: #dee2e6 !important;\r\n}\r\n\r\n.group-calendar-event td {\r\n    background-color: #5b5d58 !important;\r\n    color: #dee2e6 !important;\r\n}\r\n\r\n.calendar-event-from-log td {\r\n    background-color: #ead2ac !important;\r\n    color: #363636 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
